<template>
  <v-list-item-group color="accent">
    <v-list-item :to="target">
      <v-list-item-content>
          <v-list-item-title v-text="issue.title"></v-list-item-title>
          <v-list-item-subtitle>
            <div class="my-1 d-flex">
              <issue-status :value="issue.status"></issue-status>
              <v-spacer></v-spacer>
              <issue-stats :tasks="issue.subtasks" minimal></issue-stats>
            </div>
            <span v-html="$toText(issue.desc)"></span>
          </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'issue-card',
  props: {
    issue: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapState('routes', {
      issueRoute: state => state.PROJECT_ISSUE,
    }),
    target() {
      return {
        ...this.issueRoute.to,
        params: {
          issueId: this.issue.id,
        },
      };
    },
  },
  methods: {},
};
</script>
